// Inline artwork remains available when the network or asset request failed.
const ErrorIndicator = () => (
  <svg role="img" aria-label="Error" width="32" height="32" viewBox="0 0 24 24"
    className="text-danger flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v7" />
    <circle cx="12" cy="17" r=".5" fill="currentColor" />
  </svg>
);
export default ErrorIndicator;
